module.exports = __webpack_public_path__ + "img/zc-02.f61e238a.svg";